export enum Color {
  Purple = "purple",
  Blue = "blue",
  Pink = "pink",
  Yellow = "yellow",
  Teal = "teal",
  Rust = "rust",
  Dusk = "dusk",
  Beige = "beige"
}
